// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__18Wmk","contacts":"Contact_contacts__jil71","intro":"Contact_intro__2+BVk","info":"Contact_info__DXnb1"};